import React, { useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, Circle } from 'react-leaflet';
import mapa from './mapa.png';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import escudoAguascalientes from './images/escudosgobiernos/escudoAguascalientes.jpg';
import escudoBajaCalifornia from './images/escudosgobiernos/escudoBajaCalifornia.png';
import escudoBajaCaliforniaSur from './images/escudosgobiernos/escudoBajaCaliforniaSur.png';
import escudoCampeche from './images/escudosgobiernos/escudoCampeche.png';
import escudoCdMx from './images/escudosgobiernos/escudoCdMx.png';
import escudoChiapas from './images/escudosgobiernos/escudoChiapas.png';
import escudoChihuahua from './images/escudosgobiernos/escudoChihuahua.png';
import escudoCoahuila from './images/escudosgobiernos/escudoCoahuila.png';
import escudoColima from './images/escudosgobiernos/escudoColima.png';
import escudoDurango from './images/escudosgobiernos/escudoDurango.png';
import escudoEstadoMexico from './images/escudosgobiernos/escudoEstadoMexico.png';
import escudoGuanajuato from './images/escudosgobiernos/escudoGuanajuato.png';
import escudoGuerrero from './images/escudosgobiernos/escudoGuerrero.png';
import escudoHidalgo from './images/escudosgobiernos/escudoHidalgo.png';
import escudoJalisco from './images/escudosgobiernos/escudoJalisco.png';
import escudoMichoacan from './images/escudosgobiernos/escudoMichoacan.png';
import escudoMorelos from './images/escudosgobiernos/escudoMorelos.png';
import escudoNayarit from './images/escudosgobiernos/escudoNayarit.gif';
import escudoNuevoLeon from './images/escudosgobiernos/escudoNuevoLeon.png';
import escudoOaxaca from './images/escudosgobiernos/escudoOaxaca.png';
import escudoPuebla from './images/escudosgobiernos/escudoPuebla.png';
import escudoQueretaro from './images/escudosgobiernos/escudoQueretaro.png';
import escudoQuintanaRoo from './images/escudosgobiernos/escudoQuintanaRoo.png';
import escudoSanLuisPotosi from './images/escudosgobiernos/escudoSanLuisPotosi.png';
import escudoSinaloa from './images/escudosgobiernos/escudoSinaloa.png';
import escudoSonora from './images/escudosgobiernos/escudoSonora.jpg';
import escudoTabasco from './images/escudosgobiernos/escudoTabasco.png';
import escudoTamaulipas from './images/escudosgobiernos/escudoTamaulipas.png';
import escudoTlaxcala from './images/escudosgobiernos/escudoTlaxcala.png';
import escudoVeracruz from './images/escudosgobiernos/escudoVeracruz.png';
import escudoYucatan from './images/escudosgobiernos/escudoYucatan.png';
import escudoZacatecas from './images/escudosgobiernos/escudoZacatecas.jpg';


const MyMap = () => {
  const [selectedState, setSelectedState] = useState(null);
  const [showAllMarkers, setShowAllMarkers] = useState(true);
  const [showModal, setShowModal] = useState(false);

  const estados = [
    { nombre: 'AGUASCALIENTES', 
      serv: 'Asesoría Psicológica (emergencia en crisis) y jurídica Se enlaza con C4 de seguridad pública.',
      lugar: 'Instituto Aguascalentense de las Mujeres',
      direccion: 'Instituto Aguascalentense de las Mujeres',
      telefono: '01 449 9102128 ',
      ext: '3117, 3118',
      dias: 'Lunes a viernes',
      horario: '8:00 a 15:30 hrs',
      image: escudoAguascalientes,
      coordenadas: [21.8853, -102.2916] 
    },
    { nombre: 'BAJA CALIFORNIA',
      serv: 'Brinda atención personalizada, Psicológica y jurídica',
      lugar: 'Instituto de la Mujer del Estado de Baja California',
      direccion: 'Instituto de la Mujer del Estado de Baja California (INMUJER)',
      telefono: 'Mexicali: 01 686 558 6364 01 y 686 557 5495 . Tijuana: 01 664 608 0888 01 y 664 608 4044',
      ext: '103',
      dias: 'Lunes a viernes',
      horario: '8:00 a 17:00 hrs.',
      image: escudoBajaCalifornia,
      coordenadas: [30.8406, -115.2838] 
    },
    { nombre: 'BAJA CALIFORNIA SUR', 
      serv: 'Brinda atención personalizada, Psicológica y jurídica.',
      lugar: 'Instituto Sudcaliforniano de la Mujer',
      direccion: 'Instituto Sudcaliforniano de las Mujeres',
      telefono: '01 (612) 122 2945',
      ext: '',
      dias: 'Lunes a viernes',
      horario: '8: 00 16:00 hrs',
      image: escudoBajaCaliforniaSur,
      coordenadas: [25.6251, -111.6010] 
    },
    { nombre: 'CAMPECHE', 
      serv: 'Denuncia de violencia, asesoría e información, asesoría jurídica y psicológica',
      lugar: 'Instituto de la Mujer del Estado de Campeche',
      direccion: 'Calle 53 entre 164, circuito baluarte, centro de justicia para las mujeres, planta alta, centro histórico, C.P. 24040, Campeche',
      telefono: '01 981 811 6086 01 y 981 811 2656 ',
      ext: '114',
      dias: 'Lunes a viernes',
      horario: '8:00 a 15:00 hrs',
      image: escudoCampeche,
      coordenadas: [19.8301, -90.5349] 
    },
    { nombre: 'CHIAPAS', 
      serv: 'Trabajo social, apoyo jurídico y psicológico a través de la Fiscalía de la Mujer',
      lugar: 'Secretaría para el Desarrollo y Empoderamiento de las Mujeres (SEDEM)',
      direccion: 'Secretaría para el Desarrollo y Empoderamiento de las Mujeres',
      telefono: '01 (961) 26 40 639 y 01 (961) 26 40 643 y 01(961) 12 12 611',
      ext: '',
      dias: 'Lunes a viernes',
      horario: '8:00 a 16:00 hrs.',
      image: escudoChiapas,
      coordenadas: [16.7569, -93.1292] 
    },
    { nombre: 'CHIHUAHUA', 
      serv: 'Apoyo psicológico y jurídico',
      lugar: 'Instituto Chihuahuense de la Mujer',
      direccion: 'Instituto Chihuahuense de las Mujeres',
      telefono: '01 614 429 3505',
      ext: '15311',
      dias: 'Lunes a viernes',
      horario: '8:30 a 17:00 hrs',
      image: escudoChihuahua,
      coordenadas: [28.6330, -106.0691] 
    },
    { nombre: 'CIUDAD DE MÉXICO', 
      serv: 'A través de las 16 unidades delegacionales, brinda atención personalizada, Psicológica y jurídica.',
      lugar: 'Instituto de las Mujeres de la Ciudad de México',
      direccion: 'Instituto de las Mujeres de la Ciudad de México',
      telefono: '01 55 55 12 28 36 y Línea Mujeres 56 58 11 11  (24 hrs)',
      ext: '',
      dias: 'Lunes a viernes',
      horario: '9:00 a 17:00 hrs',
      image: escudoCdMx,
      coordenadas: [19.4326, -99.1332] 
    },
    { nombre: 'COAHUILA', 
      serv: 'Asesoría jurídica, Orientación psicológica e información en general',
      lugar: 'Secretaria de las Mujeres',
      direccion: 'Centro de Justicia y Empoderamiento para la Mujer',
      telefono: '01 (844) 698 10 85',
      ext: '',
      dias: 'Lunes a viernes',
      horario: '8:00 a 16:00 hrs',
      image: escudoCoahuila,
      coordenadas: [27.0587, -101.7068] 
    },
    { nombre: 'COLIMA', 
      serv: 'Asesoría jurídica, psicológica, canalización y atención inmediata en situaciones de emergencia',
      lugar: 'Instituto Colimense de las Mujeres',
      direccion: 'Instituto Colimense de las Mujeres',
      telefono: '01 312 316 2084, 01 312 316 2073 y Conmutador 01 312 316 2000',
      ext: '2084',
      dias: 'Lunes a viernes ',
      horario: '8:30 a 20:00 hrs',
      image: escudoColima,
      coordenadas: [19.1223, -104.0076] 
    },
    { nombre: 'DURANGO', 
      serv: 'Atención psicológica, jurídica y servicio de canalizaciones, apoyo de micro créditos a mujeres.',
      lugar: 'Instituto de la Mujer Duranguense',
      direccion: 'Instituto de la Mujer Duranguense',
      telefono: '01 618 137 4600 y 01 618 137 4602 ',
      ext: '',
      dias: 'Lunes a viernes y Sabado',
      horario: '9:00 a 20:00 hrs y 10:00 a 14:00 hrs',
      image: escudoDurango,
      coordenadas: [24.0277, -104.6532] 
    },
    { nombre: 'ESTADO DE MÉXICO', 
      serv: 'Asesoría jurídica, apoyo psicológico, información, vinculación con estancias de apoyo, canalización a instituciones de apoyo y albergues temporales para mujeres en situación de violencia.',
      lugar: 'Consejo Estatal de la Mujer y Bienestar Social',
      direccion: 'Secretaría de las Mujeres, Gobierno del Estado de México',
      telefono: 'Línea Sin Violencia 01 800 10 84 053 24 hrs y 01 (722) 213 89 15',
      ext: '',
      dias: 'Lines a viernes',
      horario: '9:00 a 18:00 hrs',
      image: escudoEstadoMexico,
      coordenadas: [19.4969, -99.7233] 
    },
    { nombre: 'GUANAJUATO', 
      serv: 'Trabajo social, psicológica y jurídica',
      lugar: 'Instituto de la Mujer Guanajuatense',
      direccion: 'Instituto para las Mujeres Guanajuatenses',
      telefono: 'Línea de Atención Servicio a Mujeres 01 (473) 733 55 23 y 01 (473) 733 32 59',
      ext: '075',
      dias: 'Lunes a viernes',
      horario: '8:30 a 16:00 hrs',
      image: escudoGuanajuato,
      coordenadas: [21.0181, -101.2574] 
    },
    { nombre: 'GUERRERO', 
      serv: 'Brinda atención personalizada, psicológica y jurídica, Módulo de atención a mujeres víctimas de violencia',
      lugar: 'Secretaria de la Mujer del Estado de Guerrero',
      direccion: 'Secretaria de la Mujer del Estado de Guerrero',
      telefono: '01(747) 471 95 33 ',
      ext: '',
      dias: 'Lunes a viernes',
      horario: '9:00 a 15:00 hrs',
      image: escudoGuerrero,
      coordenadas: [17.3616, -99.8747] 
    },
    { nombre: 'HIDALGO', 
      serv: 'Asesoría psicológica, jurídica y canalización a diversas redes de apoyo a personas en situación de violencia de género, programa de créditos, apoyo en medicamentos y apoyo de becas para mujeres en condiciones de vulnerabilidad.',
      lugar: 'Instituto Hidalguense de las Mujeres',
      direccion: 'Instituto Hidalguense de las Mujeres',
      telefono: '01 (771) 718 1550 ',
      ext: '075',
      dias: 'Lunes a viernes',
      horario: '8:30 a 18:30 hrs',
      image: escudoHidalgo,
      coordenadas: [20.0911, -98.7624] 
    },
    { nombre: 'JALISCO', 
      serv: 'Orientación psicológica, asesoría jurídica e información en general de eventos del Instituto Jalisciense de las Mujeres',
      lugar: 'Instituto Jalisciense de la Mujer',
      direccion: 'Centro de Justicia para las Mujeres Guadalajara',
      telefono: 'Línea mujer  01800 087 66 66, Instituto 01(333) 658 31 70 y 01(333) 586 61 50',
      ext: '50616',
      dias: 'Lunes a viernes',
      horario: '9:00 a 17:00 hrs',
      image: escudoJalisco,
      coordenadas: [20.6595, -103.3494] 
    },
    { nombre: 'MICHOACÁN', 
      serv: 'Brinda atención personalizada, Psicológica y jurídica',
      lugar: 'Secretaria de Igualdad Sustantiva y Desarrollo de las Mujeres',
      direccion: 'Secretaría de la Mujer Moreliana para la Igualdad Sustantiva (SEMMUJERIS)',
      telefono: '01(443) 113 67 00',
      ext: '',
      dias: 'Lunes a viernes',
      horario: '8:00 a 17:00 hrs',
      image: escudoMichoacan,
      coordenadas: [19.5665, -101.7068] 
    },
    { nombre: 'MORELOS', 
      serv: 'Brinda atención personalizada, Psicológica y jurídica. ',
      lugar: 'Instituto de la Mujer para el Estado de Morelos',
      direccion: 'Instituto de la Mujer para el Estado de Morelos',
      telefono: 'Línea de las Mujeres 01 800 911 15 15 y 01(777)173 00 66',
      ext: '',
      dias: 'Lunes a viernes',
      horario: '8:00 a 17:00 hrs',
      image: escudoMorelos,
      coordenadas: [18.6813, -99.1013] 
    },
    { nombre: 'NAYARIT', 
      serv: 'Asesoría jurídica y psicológica',
      lugar: 'Instituto de la Mujer',
      direccion: 'Instituto Para La Mujer Nayarita',
      telefono: '01 (777) 173 00 66',
      ext: '',
      dias: 'Lunes a viernes',
      horario: '8:00 a 16:00 hrs',
      image: escudoNayarit,
      coordenadas: [21.7514, -104.8455] 
    },
    { nombre: 'NUEVO LEÓN', 
      serv: 'Asesoría jurídica, psicológica y trabajo social.',
      lugar: 'Instituto Estatalo de las Mujeres en Nuevo León',
      direccion: 'Instituto Estatalo de las Mujeres en Nuevo León',
      telefono: '01 (81) 20209773, 01 (81) 20209774 y 01 800 503 7760 ',
      ext: '',
      dias: 'Lunes a viernes',
      horario: '8:00 a 17:00 hrs',
      image: escudoNuevoLeon,
      coordenadas: [25.5922, -99.9962] 
    },
    { nombre: 'OAXACA', 
      serv: 'Asesoría jurídica, psicológica, trabajo social, programas de empoderamiento económico.',
      lugar: 'Unidad de Atención a las Mujeres Victimas de Vioencia de Género',
      direccion: 'Centro de Justicia para las Mujeres, Subprocuraduría de delitos contra la Mujer por Razón de Género',
      telefono: '+52 951 514 7797 y 01 800 709 22 25 ',
      ext: '',
      dias: 'Lunes a sábado',
      horario: '8:00 a 20:00 hrs',
      image: escudoOaxaca,
      coordenadas: [17.0732, -96.7266] 
    },
    { nombre: 'PUEBLA',
      serv: 'Intervención en crisis, asesoría jurídica, psicológicos y de salud reproductiva, sexualidad y violencia con perspectiva de género.',
      lugar: 'Instituto Poblano de las Mujeres',
      direccion: 'INSTITUTO POBLANO DE LAS MUJERES',
      telefono: 'Tel Mujer 01 800 624 23 30 24 hs. y 01 (222) 30 90 900',
      ext: '',
      dias: 'Lunes a viernes',
      horario: '9:00 a 18:00 hrs',
      image: escudoPuebla,
      coordenadas: [19.0414, -98.2063] 
    },
    { nombre: 'QUERÉTARO', 
      serv: 'Orientación, asesoría legal, consejería y tratamiento psicológico a mujeres mayores de edad y/o emancipadas receptoras de violencia. Resguardo en casos necesarios',
      lugar: 'Instituto Queretano de la Mujer',
      direccion: 'Mariano Reyes #17 Col. Centro, C.P. 76000, Santiago de Querétaro, Qro.',
      telefono: 'Tel Mujer 01 80000 835 68 24 hrs. y 01 (442) 216 47 57',
      ext: '',
      dias: 'Lunes a viernes',
      horario: '8:00 a 15:30 hrs',
      image: escudoQueretaro,
      coordenadas: [20.5888, -100.3899] 
    },
    { nombre: 'QUINTANA ROO', 
      serv: 'Asesoría jurídica, psicológica y trabajo socia',
      lugar: 'Instituto Quintanarroense de la Mujer',
      direccion: 'Instituto Quintanarroense De La Mujer',
      telefono: '01 (983) 83 207 18 y 01 (983) 83 313 23',
      ext: '',
      dias: 'Lunes a viernes',
      horario: '8:00 a 16:00 hrs.',
      image: escudoQuintanaRoo,
      coordenadas: [19.1817, -88.4791] 
    },
    { nombre: 'SAN LUIS POTOSÍ', 
      serv: 'Asesoría jurídica, psicológica e intervención en crisis.',
      lugar: 'Insituto de las Mujeres del Estado de San Luis Potosí',
      direccion: 'Secretaría de las Mujeres e Igualdad Sustantivas del Estado de San Luis Potosí',
      telefono: '01 (444) 144 29 20 ',
      ext: '',
      dias: 'Lunes a viernes',
      horario: '8:00 a 20:00 hrs.',
      image: escudoSanLuisPotosi,
      coordenadas: [22.1566, -100.9855] 
    },
    { nombre: 'SINALOA', 
      serv: 'Asesorías jurídicas y psicológicas',
      lugar: 'Instituto Sinaloense de las Mujeres',
      direccion: 'Centro de Justicia para las Mujeres en Sinaloa',
      telefono: 'Línea YO ME UNO: 01 800 966 38 66  9-16 hrs. y 01 (667) 752 06 86 y 01 (667) 752 06 72',
      ext: '',
      dias: 'Lunes a viernes',
      horario: '9:00 a 16:00 hrs.',
      image: escudoSinaloa,
      coordenadas: [25.1721, -107.4795] 
    },
    { nombre: 'SONORA', 
      serv: 'Llamadas canalizadas por el 066, atención psicológica, legal, traslado en situación de violencia extrema y canalización.',
      lugar: 'Instituto Sonorense de la Mujer',
      direccion: 'Periférico Norte #328 esquina con Ignacio Romero, (entre Reforma y Monteverde), Colonia Balderrama, Hermosillo, Sonora. C.P. 83180 ',
      telefono: '01 (662) 217 49 86',
      ext: '',
      dias: 'Lunes a viernes',
      horario: '8:00 a 19:00 hrs',
      image: escudoSonora,
      coordenadas: [29.2972, -110.3300] 
    },
    { nombre: 'TABASCO', 
      serv: 'Asesoría psicológica y jurídica a mujeres que viven violencia.',
      lugar: 'Instituto Estatal de las Mujeres',
      direccion: 'Instituto Estatal de las Mujeres',
      telefono: '01 (993) 3 16 63 51',
      ext: '',
      dias: 'Lunes a viernes',
      horario: ' 8:00 a 15:00 hrs.',
      image: escudoTabasco,
      coordenadas: [17.8409, -92.6189] 
    },
    { nombre: 'TAMAULIPAS', 
      serv: 'Asesoría jurídica y psicológica',
      lugar: 'Instituto de la Mujer Tamaulipeca',
      direccion: 'Instituto Municipal De La Mujer Tamaulipeca',
      telefono: 'Línea de atención: 01 (834) 110 16 21 y 01 (834) 110 16 22 de 8 a 17 hrs.',
      ext: '',
      dias: 'Lunes a viernes',
      horario: '8:00 a 17:00 hrs',
      image: escudoTamaulipas,
      coordenadas: [24.2669, -98.8363] 
    },
    { nombre: 'TLAXCALA', 
      serv: 'Atención psicológica (terapia breve), Acompañamiento penal y Juicios familiares jurídica y trabajo social',
      lugar: 'Instituto Estatal de la Mujer',
      direccion: 'Instituto Estatal de la Mujer',
      telefono: 'Linea vida sin violencia: 1 800 838 70 73, 01 246 461 12 59 y 01 246 461 12 59 de 8 a 17 hrs.',
      ext: '',
      dias: 'Lunes a viernes',
      horario: '9:30 a 17:00 hrs.',
      image: escudoTlaxcala,
      coordenadas: [19.3139, -98.2404] 
    },
    { nombre: 'VERACRUZ', 
      serv: 'Asesoría jurídica, psicológica, trabajo social',
      lugar: 'Instituto Veracruzano de las Mujeres',
      direccion: 'Instituto Veracruzano de las Mujeres',
      telefono: '01 (228) 8170789 y 01 (228) 8171009',
      ext: '1211',
      dias: 'Lunes a viernes',
      horario: '9:00 a 15:00 hrs. y 17:00 a 19:00 hrs',
      image: escudoVeracruz,
      coordenadas: [19.1738, -96.1342] 
    },
    { nombre: 'YUCATÁN', 
      serv: 'Atención psicológica y jurídica.',
      lugar: 'Instituto para la Equidad de Género en Yucatán',
      direccion: 'SEMUJERES',
      telefono: '01 999 924 02 21 y 01 999 923 37 11',
      ext: '204, 205 y 212',
      dias: 'Lunes a viernes',
      horario: '8:00 a 20:00 hrs.',
      image: escudoYucatan,
      coordenadas: [20.7099, -89.0943] 
    },
    { nombre: 'ZACATECAS', 
      serv: 'Asesoría jurídica (patrocinio) psicológica, trabajo social y gestión social (becas, despensas medicamentos)',
      lugar: 'Secretaría de las Mujeres del estado de Zacateca',
      direccion: 'Secretaría de las Mujeres del estado de Zacateca',
      telefono: '01 492 491 5000, 01 492 491 5085 y 01 492 491 5086',
      ext: '45230, 45200',
      dias: 'Lunes a viernes',
      horario: '8:30 a 16:00 hrs',
      image: escudoZacatecas,
      coordenadas: [22.7709, -102.5832] 
    }
];

  const customIcon = new L.Icon({
    iconUrl: require('./images/pin-tel-emergencia.png'),
    iconSize: [20, 28],
    iconAnchor: [12, 41], 
    popupAnchor: [1, -34], 
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'), 
    shadowSize: [41, 41], 
  });

  const handleStateChange = (event) => {
    const stateName = event.target.value;
    const selected = estados.find((estado) => estado.nombre === stateName);
    setSelectedState(selected);
    setShowAllMarkers(false);
  };

  const handleViewInfo = (estado) => {
    setSelectedState(estado);
    setShowModal(true);
  };

  return (
    <div className="mt-6">

      {/* SELECTOR */}
      <aside className='grid lg:grid-cols-2 grid-cols-1 gap-2 p-2 bg-white'>

        <p className="my-2 ml-4">
          SELECCIONA EL ESTADO
        </p>

        <div className="items-center flex">
          <select
            className="border border-orange-500 rounded-lg w-full py-1 px-2"
            onChange={handleStateChange}
          >
            <option>Selecciona tu zona</option>

            {estados.map((estado, index) => (
              <option key={index} value={estado.nombre}>
                {estado.nombre}
              </option>
            ))}

          </select>
        </div>

      </aside>

      {/* MAPA */}

      <MapContainer
        center={[23.6345, -102.5528]}
        zoom={5}
        className="w-full h-screen"
      >

        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

        {showAllMarkers && estados.map((estado, index) => (

          <Marker
            key={index}
            position={estado.coordenadas}
            icon={customIcon}
          >

            <Popup>

              <div>

                <p className="text-violet-600 font-bold">
                  {estado.nombre}
                </p>

                <p>
                  Conoce los números de emergencia
                </p>

                <button
                  className="rounded-lg bg-violet-400 text-white text-md p-2 mt-2"
                  onClick={() => handleViewInfo(estado)}
                >
                  Ver información →
                </button>

              </div>

            </Popup>

          </Marker>

        ))}

        {selectedState && (

          <Circle
            center={selectedState.coordenadas}
            radius={50000}
            pathOptions={{ color: "orange" }}
          />

        )}

      </MapContainer>

      {/* MODAL */}

      {showModal && selectedState && (

        <div className="fixed inset-0 bg-black bg-opacity-50 z-[9999] flex items-center justify-center p-4">

          <div className="bg-white rounded-xl w-full max-w-2xl max-h-[85vh] overflow-y-auto shadow-xl">

            {/* HEADER */}

            <div className="flex justify-between items-center border-b p-4">

              <h2 className="text-2xl font-bold text-violet-600">
                {selectedState.nombre}
              </h2>

              <button
                onClick={() => setShowModal(false)}
                className="text-2xl"
              >
                ×
              </button>

            </div>

            {/* CONTENIDO */}

            <div className="p-6 space-y-4 text-black">

              <div className="flex justify-center">

                <img
                  src={selectedState.image}
                  alt="escudo"
                  className="w-24"
                />

              </div>

              <p className="font-semibold text-center">
                {selectedState.serv}
              </p>

              <div>
                <strong>Institución:</strong>
                <p>{selectedState.lugar}</p>
              </div>

              <div>
                <strong>Dirección:</strong>

              <a
                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(selectedState.direccion + " " + selectedState.nombre + " Mexico")}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline hover:text-blue-800"
              >
                📍 {selectedState.direccion}
              </a>
              </div>

              <div>
                <strong>Teléfono:</strong>

                <p className="text-lg text-violet-600 font-bold">

                  <a href={`tel:${selectedState.telefono}`}>
                    {selectedState.telefono}
                  </a>

                </p>

              </div>

              <div>
                <strong>Extensiones:</strong>
                <p>{selectedState.ext || "No disponible"}</p>
              </div>

              <div>
                <strong>Horario:</strong>
                <p>
                  {selectedState.dias} de {selectedState.horario}
                </p>
              </div>

              <div className="flex justify-end pt-4">

                <button
                  onClick={() => setShowModal(false)}
                  className="bg-violet-500 text-white px-4 py-2 rounded-lg"
                >
                  Cerrar
                </button>

              </div>

            </div>

          </div>

        </div>

      )}

    </div>
  );
};

export default MyMap;